import { Step } from 'signup-constants/Step';
import { FlowStateManager } from '../flow-management/FlowStateManager';
import { getIsActiveAndAssignedToVariant } from '../store/experiments/selectors';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { trackAcq145ExposureForGooglePrompt } from '../experiments/acq0145/acq145Tracking';
import { setFlowForACQ145 } from '../experiments/acq0145/ACQ145Utils';
import { setFlowForCOAC0001, trackCOAC0001ExposureForGooglePrompt } from '../experiments/coac-0001/COAC001Utils';
export const setFlowAfterGoogleCredentialAuthentication = response => (dispatch, getState) => {
  const state = getState();
  const isEnrolledACQ0145Variant = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0145, [ExperimentParameterGroup.Variant_A]);
  const isEnrolledCOAC0001Variant = getIsActiveAndAssignedToVariant(state, ExperimentKeys.COAC0001, [ExperimentParameterGroup.Variant_A, ExperimentParameterGroup.Variant_B]);
  const stepsToRemove = [...(response.email ? [Step.LandingPage] : []), Step.Verification, Step.CodeVerification, Step.Password, ...(response.firstName && response.lastName ? [Step.Name] : [])];
  if (isEnrolledACQ0145Variant) {
    dispatch(setFlowForACQ145({
      stepsToRemove
    }));
  } else if (isEnrolledCOAC0001Variant) {
    dispatch(setFlowForCOAC0001({
      stepsToRemove
    }));
  } else {
    dispatch(FlowStateManager.removeSteps(stepsToRemove));
  }
  trackAcq145ExposureForGooglePrompt(state);
  trackCOAC0001ExposureForGooglePrompt(state);
};